import { Search } from '@ori-ui/icons';
import useTestId from '@ori/testid-generator';
import { useCallback } from 'react';

import { useActiveMenu, useSearchInput } from '../../context/navigation';
import { useSearchInputPlaceholder } from '../../hooks/useSearchInputPlaceholder';
import { SEARCH_ICON } from './constants';
import { SearchIconRoot } from './styles';

export const SearchIcon = () => {
  const { hideSearchResultsTab } = useActiveMenu();
  const { isVisible, hide, show, manualShow, manualHide } = useSearchInput();
  const { getTestId } = useTestId();
  const searchPlaceholder = useSearchInputPlaceholder();

  const handleClick = useCallback(() => {
    if (isVisible) {
      manualHide();
      hide();
      hideSearchResultsTab();
    } else {
      show();
      manualShow();
    }
  }, [hide, hideSearchResultsTab, isVisible, manualHide, manualShow, show]);

  return (
    <SearchIconRoot
      disableRipple
      aria-label={searchPlaceholder}
      data-testid={getTestId(SEARCH_ICON)}
      onClick={handleClick}
    >
      {isVisible ? null : <Search fontSize="inherit" />}
    </SearchIconRoot>
  );
};
